import {InputText} from "primereact/inputtext";
import {Classes, Labeled} from "./Basics";

type Properties = Classes & Labeled & {
    val: any
    onChange: (val: number) => void
}

function InputNumberProperty(props: Properties) {
    function handleOnChange(e: any) {
        if (props.onChange != null) {
            if (!Number.isNaN(+e.target.value)) {
                props.onChange(+e.target.value)
            }
            e.preventDefault()
        }
    }

    return <>
        <div className={"property-element"}>
            <label
                className={"label" + (props.labelAdditionalClassName == null ? "" : (" " + props.labelAdditionalClassName))}>
                {props.label}
            </label>
            <InputText
                className={"item" + (props.inputAdditionalClassName == null ? "" : (" " + props.inputAdditionalClassName))}
                value={props.val}
                onChange={handleOnChange}
                placeholder={props.label}
            />
        </div>
    </>
}

export default InputNumberProperty